<template>
    <v-layout row>
        <v-flex xs12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="backToPrevPage">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-chip v-if="!isMy201FilesPage" @click="$router.push(`/hr/employees/${$route.params.userId}`)" label outline small title="View user profile">
                        <v-icon>person</v-icon>
                        <span class="user-profile white--text ml-10">View User Profile</span>
                    </v-chip>
                </v-toolbar>
            </v-card>

            <!-- details -->
            <v-layout row wrap>
                <!-- 201 files -->
                <v-flex xs12 sm9>
                    <v-card class="elevation-1" >
                        <v-toolbar flat height="40">
                            <v-chip v-if="!isMobile&&folders.length">
                                <v-icon :color="selectedFolderColor">folder</v-icon>&nbsp;&nbsp;<b class="primary--text lighten-2">
                                    {{ selectedFolderName }} 
                                    <span class="grey--text text--darken-1">({{ selectedFolderFileCount }})</span>
                                </b>
                            </v-chip>
                            <span v-if="isMobile">
                                <v-menu v-if="folders.length" left v-model="menu_status" offset-y> 
                                    <template v-slot:activator="{ on }">
                                        <v-btn :color="selectedFolderColor" v-on="on">
                                            &nbsp;&nbsp;{{selectedFolderName}}&nbsp;&nbsp;
                                            <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                            <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-tile v-for="(item,index) in folders" :key="index" @click="viewFiles(item)">
                                            <v-list-tile-title small>{{item.folderName}}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="isMobile&&hasAddRights&&!isMy201FilesPage" icon title="Create folder" @click="showCreateFolder">
                                <v-icon color="#F9A825">create_new_folder</v-icon>
                            </v-btn>
                            <v-btn v-if="hasEditRights&&isActiveAccount&&folders.length" icon title="Upload file" @click="showUpload">
                                <v-icon color="primary">cloud_upload</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile ? [] : headers"
                            :items="files"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                            :hide-headers="isMobile"
                        >  
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="headers.length" class="pa-1">
                                        <v-card class="elevation-1" @click="preview(props.item)">
                                            <v-toolbar flat height="42">
                                                <v-btn icon class="ml-0">
                                                    <v-icon :color="getFileTypeIcon(props.item.fileType).color">{{ getFileTypeIcon(props.item.fileType).icon }}</v-icon>
                                                </v-btn>
                                                <span class="clickable ml-5">{{ props.item.documentName }}</span>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-1">
                                                    <v-layout row>
                                                        <v-flex xs3>
                                                            Label
                                                        </v-flex>
                                                        <v-flex xs9>
                                                            <b class="downloadable-link">{{ props.item.label }}</b>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs3>
                                                            Uploaded On 
                                                        </v-flex>
                                                        <v-flex xs9>
                                                            <b>{{ props.item.uploadedOn | moment('MMM DD, YYYY') }}</b>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs3>
                                                            Uploaded By
                                                        </v-flex>
                                                        <v-flex xs9>
                                                            <v-chip small class="user-chip-container ">
                                                                <v-avatar>
                                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.uploadedByUser.userId)"></v-img>
                                                                </v-avatar>
                                                                {{props.item.uploadedByUser.firstName}} {{props.item.uploadedByUser.lastName}}
                                                            </v-chip>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-card-actions @click.stop>                                        
                                                <v-spacer></v-spacer>
                                                <v-btn v-if="hasEditRights" icon small @click="showEditUpload(props.item)">
                                                    <v-icon small>edit</v-icon>
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>                                        
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else @click="preview(props.item)" class="clickable" title="Click to preview file">
                                    <td>
                                        <v-btn icon style="margin-left:-8px;">
                                            <v-icon :color="getFileTypeIcon(props.item.fileType).color">{{ getFileTypeIcon(props.item.fileType).icon }}</v-icon>
                                        </v-btn>
                                    </td>
                                    <td>
                                        <span class="downloadable-link">{{ props.item.documentName }}</span>
                                    </td>
                                    <td>
                                        <span class="downloadable-link">{{ props.item.label }}</span>
                                    </td>
                                    <td>
                                        {{ props.item.uploadedOn | moment('MMM DD, YYYY') }}
                                    </td>
                                    <td>
                                        <v-chip small class="user-chip-container">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.uploadedByUser.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.uploadedByUser.firstName}} {{props.item.uploadedByUser.lastName}}
                                        </v-chip>
                                    </td>
                                    <td @click.stop>
                                        <v-btn v-if="hasEditRights" icon small @click="showEditUpload(props.item)" title="Click to edit" class="upload-edit">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
                
                <!-- 201 folders -->
                <v-flex v-if="!isMobile" xs12 sm3>
                     <v-card class="elevation-1">
                        <v-toolbar flat height="37">
                            <b>201 Folders</b>
                            <v-spacer></v-spacer>
                            <!-- Do not allow creation of folder in My 201 Files page -->
                            <v-btn v-if="hasAddRights&&!isMy201FilesPage&&folders.length" icon title="Create folder" @click="showCreateFolder">
                                <v-icon color="#F9A825">create_new_folder</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-progress-linear v-if="loading_folders" indeterminate height="2" class="mt-0"></v-progress-linear>
                        <div v-if="!loading_folders" class="ml-10">
                            <div v-if="folders.length" row wrap class="menu-container">
                                <v-chip v-for="(item, index) in folders" :key="index" class="folder-chip">
                                    <v-icon :color="item.color" class="mr-5">folder</v-icon>
                                    <span @click="viewFiles(item)" :class="isSelected(item) ? 'menu-link-selected primary--text lighten-2': 'menu-link'" :title="`Click to view ${item.folderName} files`">
                                        {{ item.folderName }}
                                         <span class="grey--text text--darken-1">
                                            ({{ item.fileCount || 0 }})
                                        </span>
                                    </span>
                                    <v-btn v-if="!isMy201FilesPage&&hasEditRights" icon small @click="showEdit(item)" class="menu-edit" style="">
                                        <v-icon small title="Edit folder">edit</v-icon>
                                    </v-btn>
                                </v-chip>
                            </div>
                            <div v-else row wrap class="text-xs-center menu-container">
                                <p class="mt-5">
                                    You don't have any 201 folders yet. 
                                    <span v-if="!isMy201FilesPage">
                                        <br>Start by creating one — <br>it will be available for all users.
                                    </span>
                                </p>
                                <v-btn v-if="hasEditRights && !isMy201FilesPage" flat @click="showCreateFolder">
                                    <v-icon class="mr-2">folder_open</v-icon>
                                    Create folder
                                </v-btn>
                            </div>
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- comments and update history components -->
             <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="dialogFolder" persistent width="500">
            <add-edit-folder ref="refFolderComponent" :dialogFolder.sync="dialogFolder" @send="createFolderHandler"></add-edit-folder>
        </v-dialog>
        <v-dialog v-model="dialogUpload" persistent width="650">
            <upload ref="refUploadComponent" :dialogUpload.sync="dialogUpload" @send="uploadHandler"></upload>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>
import awsS3Helper from '@/helpers/aws-s3'
import hr201Api from '@/api/hr201'
import pageKeys from '@/common/pagekeys'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import { hasAddRights, hasEditRights } from '@/helpers/access-permissions'
import { getFileTypeIcon } from '@/helpers/file-color-icons'

export default {  
    name: 'HR201Files',
    metaInfo: {
        title: 'HR 201 Files',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View HR 201 Files' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'add-edit-folder': () => import('@/components/201Files/AddEditFolder'),
        'upload': () => import('@/components/201Files/UploadFiles'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            awsS3Helper,
            rowsPerPageItems,
            getFileTypeIcon,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            disabled: false,
            loading_folders: false,
            loading_download: false,
            menu_status: false,
            error: false,
            errorMessage: '',
            headers: [
                {text:'File', align: 'left',value:'fileType', width:'5%', sortable:true},
                {text:'Document Type', align: 'left',value:'documentName', width:'35%', sortable:true},
                {text:'Label', align: 'left',value:'label', width:'35%', sortable:true},
                {text:'Uploaded On', align: 'left',value:'uploadedOn', width:'10%', sortable:true},
                {text:'Uploaded By', align: 'left',value:'lastName', width:'10%', sortable:true},
                {text:'', align: 'left',value:'team', width:'5%', sortable:false},
            ],
            dialogFolder: false,
            dialogUpload: false,    
            dialogPreview: false,
            selectedFolderId: null,
            selectedFolderName: 'Select folder to view and upload files',
            selectedFolderColor: '',
            selectedFolderFileCount: 0,
            folders: [],
            files: []
        }
    },
    methods: {
        backToPrevPage(){
            if (this.isMy201FilesPage) this.$router.push(`/hr`)
            else this.$router.push(`/hr/201`)
        },
        isSelected(data) {
            return data.folderId == this.selectedFolderId
        },
        async preview(data) {
            const downloadUrl = awsS3Helper.getEmployeeDocumentUrl(
                data.userId,
                data.fileName,
                AWSS3DocumentType.HR201
            )

            const file = {
                name: data.label,
                type: data.fileType,
                url: '',
                downloadUrl
            }

            const requiresSignedUrl = ['WordDocument', 'Pdf'].includes(data.fileType)

            if (requiresSignedUrl) {
                const response = await hr201Api.getPreSignedUrl(
                    {
                        fileName: data.fileName,
                        userId: this.selectedUserId
                    },
                    this.selectedPageKey
                )

                if (!response || response.status !== 200) return

                file.url = response.data
            } else {
                file.url = downloadUrl
            }

            this.$refs.refPreviewComponet.setParams(file)
            this.dialogPreview = true
        },
        showEdit(data) {
            this.$refs.refFolderComponent.setEdit(data)
            this.dialogFolder = true
        },
        showEditUpload(data) {
            this.$refs.refUploadComponent.setEdit(data)
            this.dialogUpload = true
        },
        showCreateFolder() {
            this.$refs.refFolderComponent.setAdd()
            this.dialogFolder = true
        },
        showUpload() {
            this.$refs.refUploadComponent.setParams(this.selectedFolderId, this.selectedUserId)
            this.dialogUpload = true
        },
        viewFiles(data) {
            if (this.selectedFolderId != data.folderId) {
                this.selectedFolderName = data.folderName
                this.selectedFolderColor = data.color
                this.selectedFolderId = data.folderId
                this.selectedFolderFileCount = data.fileCount
                this.getUploadsByFolder()
            }
        },
        async getUploadsByFolder() {
            try{
                this.loading_files = true
                const response = await hr201Api.getUploads(this.selectedUserId, this.selectedFolderId, this.selectedPageKey)
                if (response && response.status == 200) {
                    this.files = response.data.items
                }
                this.loading_files = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async createFolderHandler(folderId) {
            await this.getFolders(false)
            if (folderId && this.folders.length) {
                const createdFolder = this.folders.filter(x => x.folderId == folderId)[0]
                this.viewFiles(createdFolder)
            }else{
                this.viewFiles(this.folders[0])
            }
        },
        async getFolders(show_loading) {
            try{
                this.loading_folders = show_loading
                const response = await hr201Api.getFolders(this.selectedUserId, this.selectedPageKey)
                if (response && response.status == 200) {
                    this.folders = response.data.folders
                }
                this.loading_folders = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        async uploadHandler() {
            await  this.getUploadsByFolder()
            await this.getFolders(false)
            this.selectedFolderFileCount = this.folders.find(x => x.folderId == this.selectedFolderId).fileCount
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) {
                if (this.selectedFolderId) {
                    this.getUploadsByFolder()
                }
            }

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: this.isMy201FilesPage ? 'My 201 Files' : `${this.selectedUserName} - 201 Files`,
            avatarPath: awsS3Helper.getProfileAvatarUrl(this.selectedUserId)
        })
        
        await this.getFolders(true)

        if (this.folders.length) {
            this.viewFiles(this.folders[0])
        }
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        isMy201FilesPage() {
            return !this.$route.params.userId
        },
        selectedUserId() {
            if (this.$route.params.userId)
                return this.$route.params.userId //accessed from HR > 201 Files > Selected employeee
            else 
                return this.$store.state.userId //accessed from HR > My 201 Files
        },
        selectedPageKey() {
            return this.isMy201FilesPage ? pageKeys.myhr201 : pageKeys.hr201
        },
        pageQueryId() {
            return `hr201-${this.selectedUserId}`
        },
        commentsData() {
            return { pageQueryId: this.pageQueryId }
        },
        isActiveAccount() {
            return this.isMy201FilesPage || (
                    this.$store.state.selectedTwoZeroOneUser && 
                    !this.$store.state.selectedTwoZeroOneUser.deactivated
                )
        },
        selectedUserName() {
            return `${this.$store.state.selectedTwoZeroOneUser.firstName} ${this.$store.state.selectedTwoZeroOneUser.lastName}`
        }
    },
}
</script>
<style scoped>
.files-header {
    margin-bottom:10px;
}
.menu-link {
  cursor: pointer;
}
.menu-link:hover {
  text-decoration: underline;
}
.menu-link-selected {
  cursor: pointer;
  font-weight: bold;
}
.menu-link-selected:hover {
  text-decoration: underline;
}
.menu-edit {
  display: none; /* hide by default */
  right:0px;
  position:absolute;
}
.v-chip:hover .menu-edit {
  display: inline-flex; /* show on hover */
}
.menu-container {
    padding:8px;
}
.file-card {
    border-radius:5px;
    height:auto;
}
.upload-edit {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease;
    margin-left: -8px;
}
tr:hover .upload-edit {
  visibility: visible;
  opacity: 1;
}
.downloadable-link:hover {
    text-decoration: underline;
    cursor: pointer;
}
.clickable {
    cursor: pointer;
}
.user-profile {
    cursor: pointer;
}
.user-profile:hover {
    text-decoration: underline;
}
.section-layout {
    padding:0px 23px 0px 23px;
}
.folder-chip {
    display: flex;
    width: 100%;
    margin-bottom: 6px;
}
.folder-chip .v-chip__content {
    display: flex;
    width: 100%;
    align-items: center;
}
.folder-chip .menu-edit {
    margin-left: auto;
}
</style>
